import _ from 'lodash';

import asanaIcon from '../assets/images/integrations/asana.svg';
import azureIcon from '../assets/images/integrations/azure.svg';
import fileIcon from '../assets/images/integrations/file.svg';
import jiraIcon from '../assets/images/integrations/jira.svg';
import jiraCloudIcon from '../assets/images/integrations/jira-cloud.svg';
import trelloIcon from '../assets/images/integrations/trello.svg';
import akbIcon from '../assets/images/integrations/advanced-kanban.svg';

import { windowLocation } from './url';

export const INTEGRATIONS = {
  'asana': {
    app: 'asana',
    icon: asanaIcon,
    name: 'Asana',
    boardsName: 'Asana Boards',
    field: 'email',
    login: 'api/integrations/login',
    connect: 'api/integrations/login',
    params: {}
  },
  'azure': {
    app: 'azure',
    icon: azureIcon,
    name: 'Azure DevOps',
    boardsName: 'Azure DevOps Boards',
    field: 'host',
    login: 'login',
    connect: 'api/integrations/login',
    params: {}
  },
  'file': {
    app: 'file',
    icon: fileIcon,
    name: 'CSV/JSON File',
    boardsName: 'CSV/JSON File Boards',
    field: 'email',
    login: '',
    params: {}
  },
  'jira': {
    app: 'jira',
    icon: jiraCloudIcon,
    name: 'Jira Cloud',
    boardsName: 'Jira Boards',
    field: 'host',
    login: 'api/integrations/login',
    connect: 'login',
    params: { cloud: true }
  },
  'jira-server': {
    app: 'jira',
    icon: jiraIcon,
    name: 'Jira Server & Jira Data Center',
    boardsName: 'Jira Boards',
    field: 'host',
    login: 'login',
    connect: 'api/integrations/login',
    params: { server: true }
  },
  'jira-akb': {
    app: 'jira',
    icon: akbIcon,
    name: 'Advanced Kanban & Agile',
    boardsName: 'Advanced Kanban & Agile Boards',
    field: 'host',
    login: 'login',
    params: {}
  },
  'trello': {
    app: 'trello',
    icon: trelloIcon,
    name: 'Trello',
    boardsName: 'Trello Boards',
    field: 'email',
    login: 'api/integrations/login',
    params: {}
  },
};

export function getSwitchConnectionMessage(dashboard, app, user) {
  const sameAccount = dashboard.accountId === user.selectedAccount;
  const sameApp = app === dashboard.application;
  const hostApp = dashboard.application === 'jira' || dashboard.application === 'azure';
  if (!sameAccount && hostApp) {
    const connection = _.find(user.integrations, { application: dashboard.application, accountId: dashboard.accountId });
    return connection && connection.linked ? 
      true :
      connection ?
        `Please connect to your "${_.upperFirst(connection.application)} / ${connection.host}" account first in "Manage Connections"` :
        `Please add your "${_.upperFirst(dashboard.application)}" connection first in "Manage Connections"`;
  }
  if (!sameAccount && !sameApp) {
    const connection = _.find(user.integrations, { application: dashboard.application });
    return connection && connection.linked ? 
      true :
      `Please add your "${_.upperFirst(dashboard.application)}" connection first in "Manage Connections"`;
  }
}

export function beautifyHost(host) {
  if (!host) return '';
  return host.replace(/^https?:\/\//, '').replace(/\/+$/, '');
}

export function prepareUrl(app, path = '/', query = {}) {
  const urlParts = windowLocation().host.split('.');
  const queryParams = _.keys(query)
    .filter(k => !!query[k])
    .map((k, i) => (i ? '': '?') + `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
    .join('&');
  const link = `https://${app}.${urlParts[1]}.${urlParts[2]}/${path}${queryParams}`;
  return link;
}

export default {
  getSwitchConnectionMessage,
  beautifyHost,
  prepareUrl,
  INTEGRATIONS
}